<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { wait } from '../../../../helpers/utilities';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Checkbox, Button, Text, Modal, Container } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';

	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	$: settingsStore = getDeviceSettings(id);
	$: statusStore = getDeviceStatus(device.id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore;
	let checked = settings.tilt_enabled,
		showModal = false,
		waitForResponse = false,
		waitForCalibrate = false;

	const calibrateDevice = async () => {
		showModal = false;
		waitForCalibrate = true;
		const res = await postReq(
			//this is called only in beginnig of calibration, didn't see oposite call so value will be 1
			`/device/sensor/settings/set_command`,
			{
				id,
				set: 'calibration_mode',
				command: 1,
			},
		);
		if (res?.isok) {
			//this is optional, because sometimes reqest is canceled and it isn't handled yet
			const resC = await postReq(`device/sensor/settings/tilt_setup`, {
				id,
				opened: Number($statusStore.sensor.state === 'open'),
			});
			if (resC?.isok) {
				await wait(10000);
				if ($settingsStore.tilt_calibrated) {
					return onSettingsResponse(
						{
							isok: true,
						},
						device,
					);
				}
			}
		}
		onSettingsResponse(res, device);
		waitForCalibrate = false;
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: enableTiltFunction,
				loading: waitForResponse,
				disabled: waitForResponse,
				label: $format('button_apply', { default: 'apply' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});

	const enableTiltFunction = async () => {
		waitForResponse = true;
		if (checked && !settings.tilt_calibrated) {
			//if enabled show modal and go calibrate
			showModal = true;
		} else {
			const res = await postReq(`/device/sensor/settings/tilt_enable`, {
				id,
				enabled: Number(checked),
			});
			onSettingsResponse(res, device);
		}
		waitForResponse = false;
	};
</script>

<Checkbox size="m" class="mb-s" bind:checked id="checkbox-2hkh608"
	>{$format('tilt_functions_enable', {
		default: 'Enable/Disable tilt functions.',
	})}</Checkbox
>

{#if checked && $settingsStore.tilt_enabled}
	<Button size="m" class="mb-s" width="full" loading={waitForCalibrate} on:click={calibrateDevice}
		>{$format('button_start_calibration', {
			default: '"Start calibration"',
		})}</Button
	>
{/if}

{#if !$showNewLayout}
	<Button
		size="m"
		class="text-uppercase"
		width="full"
		loading={waitForResponse}
		on:click={enableTiltFunction}>{$format('button_apply', { default: 'apply' })}</Button
	>
{/if}
<!-- TODO add modal title translation label_confirmation -->
<Modal
	on:close={() => (showModal = false)}
	{showModal}
	backdropClose={true}
	title={$format('label_confirmation', { default: 'Confirmation' })}
>
	<svelte:fragment slot="content">
		<Container padding="0">
			<Text class="mb-s"
				>{$format('tilt_close_prompt', {
					default: 'Please close your window, then click "done".',
				})}</Text
			>
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (showModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={calibrateDevice}
		>
			{$format('button_done', { default: 'Done' })}
		</Button>
	</div>
</Modal>
